const stateKey = "photoshootNavigationV3";
let lastState = null;
let lastUrl = null;

export function navigationHistorySnapshot() {
    const state = window.history.state;
    return state && typeof state[stateKey] === "string" ? state[stateKey] : null;
}

export function writeNavigationHistory(snapshot, route, replace) {
    const url = new URL(window.location.href);
    url.hash = route;
    const current = window.history.state;
    const state = { ...(current && typeof current === "object" ? current : {}), [stateKey]: snapshot };
    if (replace || navigationHistorySnapshot() === snapshot) {
        window.history.replaceState(state, "", url.href);
    } else {
        window.history.pushState(state, "", url.href);
    }
    lastState = state;
    lastUrl = url.href;
}

export function pushNavigationBackGuard() {
    window.history.pushState(window.history.state, "", window.location.href);
}

export function watchNavigationHistory(onRestore, onBack) {
    lastState = window.history.state;
    lastUrl = window.location.href;
    const restore = () => {
        const snapshot = navigationHistorySnapshot();
        // Browsers can emit both events for one fragment traversal.
        if (lastUrl === window.location.href &&
            lastState?.[stateKey] === snapshot) return;
        lastState = window.history.state;
        lastUrl = window.location.href;
        onRestore(snapshot, window.location.hash.substring(1));
    };
    const pop = () => {
        if (onBack()) {
            // Dismissing an overlay must not also navigate the screen behind it.
            window.history.pushState(lastState, "", lastUrl);
            return;
        }
        restore();
    };
    window.addEventListener("popstate", pop);
    window.addEventListener("hashchange", restore);
    return { pop, restore };
}

export function stopNavigationHistory(watcher) {
    window.removeEventListener("popstate", watcher.pop);
    window.removeEventListener("hashchange", watcher.restore);
}
